/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_SubmitInputs */

const en_auth_signup_submit = /** @type {(inputs: Auth_Signup_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up`)
};

const pl_auth_signup_submit = /** @type {(inputs: Auth_Signup_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarejestruj się`)
};

/**
* | output |
* | --- |
* | "Sign up" |
*
* @param {Auth_Signup_SubmitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_submit = /** @type {((inputs?: Auth_Signup_SubmitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_SubmitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_submit(inputs)
	return en_auth_signup_submit(inputs)
});